import React, { useEffect } from 'react';
import Prism from 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';
import 'prismjs/components/prism-javascript.js';
import 'prismjs/plugins/normalize-whitespace/prism-normalize-whitespace';
import 'prismjs/plugins/line-numbers/prism-line-numbers.js';
import 'prismjs/plugins/line-numbers/prism-line-numbers.css';
import 'prismjs/plugins/line-highlight/prism-line-highlight.js';
import 'prismjs/plugins/line-highlight/prism-line-highlight.css';
import 'prismjs/plugins/toolbar/prism-toolbar.js';
import 'prismjs/plugins/toolbar/prism-toolbar.css';
import 'prismjs/plugins/match-braces/prism-match-braces.js';
import 'prismjs/plugins/match-braces/prism-match-braces.css';
import 'prismjs/plugins/treeview/prism-treeview.js';
import 'prismjs/plugins/treeview/prism-treeview.css';
import 'prismjs/plugins/highlight-keywords/prism-highlight-keywords.js';
import 'prismjs/plugins/download-button/prism-download-button.js';
import 'prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard.js';
//import "../../../assets/prismjs/prism.js";
//import "../../../assets/prismjs/prism.css";
export default function CodeHighlighter({ code }) {
  useEffect(() => {
    Prism.highlightAll();
  }, [Prism, code]);

  return (
    <div style={{ maxHeight: 450, overflowY: 'auto' }}>
      <pre
        className={
          'line-numbers line-highlight highlight-keywords copy-to-clipboard-button download-button match-braces treeview'
        }
      >
        <code className={'language-javascript'}>{code}</code>
      </pre>
    </div>
  );
}
